import React from 'react';
import { X, Edit3, ShieldCheck, Key } from 'lucide-react';

function ProfileModal({ show, onClose, tin, setTin, asilToken, setAsilToken, didoxToken, setDidoxToken, handleUpdateProfile }) {
  if (!show) return null;

  return (
    <div className="fixed inset-0 bg-slate-950/80 backdrop-blur-md z-[120] flex items-center justify-center p-6">
      <div className="bg-slate-900 rounded-[50px] w-full max-w-xl p-10 shadow-2xl border border-blue-500/20 relative scale-in max-h-[90vh] overflow-y-auto custom-scrollbar">
        <button onClick={onClose} className="absolute top-8 right-8 p-3 bg-white/5 text-slate-500 hover:text-rose-500 rounded-2xl transition border border-white/5"><X size={24}/></button>

        <div className="flex flex-col items-center mb-10">
          <div className="w-16 h-16 bg-blue-600/10 rounded-2xl flex items-center justify-center text-blue-500 mb-4 border border-blue-500/20 shadow-lg shadow-blue-900/20">
            <ShieldCheck size={32} />
          </div>
          <h3 className="text-2xl font-black text-white">API Sozlamalari</h3>
          <p className="text-slate-500 text-xs font-bold mt-1 uppercase tracking-widest">Integratsiya Sozlamalari</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          <div className="space-y-6">
            <div className="space-y-2">
                <label className="text-[10px] font-black uppercase text-blue-400 block ml-2 tracking-widest opacity-80">STIR raqamingiz (INN)</label>
                <input
                    type="text"
                    className="w-full p-5 bg-slate-950 border border-white/5 rounded-[25px] outline-none font-black text-white placeholder-slate-800 focus:border-blue-500/30 transition-all shadow-inner"
                    value={tin}
                    onChange={e => setTin(e.target.value)}
                    placeholder="STIR..."
                />
            </div>

            <div className="space-y-2">
                <label className="text-[10px] font-black uppercase text-emerald-400 block ml-2 tracking-widest opacity-80">Asil Belgi API Token</label>
                <textarea
                    className="w-full p-5 bg-slate-950 border border-white/5 rounded-[25px] outline-none font-bold h-40 text-white placeholder-slate-800 focus:border-emerald-500/30 transition-all shadow-inner leading-relaxed custom-scrollbar text-[10px]"
                    value={asilToken}
                    onChange={e => setAsilToken(e.target.value)}
                    placeholder="Asil Belgi token..."
                />
            </div>
          </div>

          <div className="space-y-6">
            <div className="space-y-2">
                <label className="text-[10px] font-black uppercase text-blue-500 block ml-2 tracking-widest opacity-80">Didox API Token</label>
                <textarea
                    className="w-full p-5 bg-slate-950 border border-white/5 rounded-[25px] outline-none font-bold h-60 text-white placeholder-slate-800 focus:border-blue-500/30 transition-all shadow-inner leading-relaxed custom-scrollbar text-[10px]"
                    value={didoxToken}
                    onChange={e => setDidoxToken(e.target.value)}
                    placeholder="Didox API tokenini shu yerga tashlang..."
                />
            </div>
          </div>
        </div>

        <button
            onClick={handleUpdateProfile}
            className="w-full bg-blue-600 text-white py-6 rounded-[30px] font-black hover:bg-blue-700 transition shadow-xl shadow-blue-900/40 active:scale-95 tracking-widest mt-8 uppercase text-sm"
        >
            BARCHA SOZLAMALARNI SAQLASH
        </button>
      </div>
    </div>
  );
}

export default ProfileModal;
